// Thin route wrapper for canonical document pages.

import React from 'react';
import { Navigate, useLocation } from 'react-router';
import { getDocumentByRoute } from '@airhead-games/shared/content';
import DocumentTemplate from '@/content/rendering/templates/DocumentTemplate';

interface DocumentRouteProps {
  fallbackPath?: string;
}

const DocumentRoute: React.FC<DocumentRouteProps> = ({
  fallbackPath = '/discover',
}) => {
  const location = useLocation();
  const document = getDocumentByRoute(location.pathname);

  if (!document) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <DocumentTemplate document={document} />;
};

export default DocumentRoute;
